import { OrderOptimizerListItemRoute } from "../../../../../common/services/order-optimizer/list/order-optimizer-list";
import OrderOptimizerRoadRouteParams, {
  OrderOptimizerRoadRouteParamsWaypoints,
} from "../../../../../common/services/order-optimizer/road-route/order-optimizer-road-route-params";
import {
  OrderOptimizerCargoListingItemRoute,
  OrderOptimizerCargoListingItem,
} from "./types/order-optimizer-cargo-listing-item";

const createWaypoint = (
  address: OrderOptimizerListItemRoute,
): OrderOptimizerCargoListingItemRoute => {
  return {
    lat: address.lat,
    lon: address.lon,
    orderHumanId: address.orderHumanId,
  };
};

const createWaypoints = (
  responseTransportingOrderOptimizations: OrderOptimizerCargoListingItem,
): OrderOptimizerCargoListingItemRoute[][] => {
  const splitWaypoints: OrderOptimizerListItemRoute[][] = [];

  responseTransportingOrderOptimizations.orders.forEach((order) => {
    splitWaypoints.push(
      responseTransportingOrderOptimizations.route.filter(
        (point) => point.orderHumanId === order.humanId,
      ),
    );
  });

  return splitWaypoints.map((route) => route.map(createWaypoint));
};

const createSearchRoutingCoordinate = (
  waypoint: OrderOptimizerCargoListingItemRoute,
): OrderOptimizerRoadRouteParamsWaypoints => {
  return {
    lat: waypoint.lat,
    lon: waypoint.lon,
  };
};

const createSearchRoutingRequest = (
  waypoints: OrderOptimizerCargoListingItemRoute[],
): OrderOptimizerRoadRouteParams => {
  const request: OrderOptimizerRoadRouteParams = {
    waypoints: waypoints.map(createSearchRoutingCoordinate),
  };

  return request;
};

const orderOptimizerCargoDetailsWaypointFactory = {
  createWaypoints,
  createSearchRoutingRequest,
};

export default orderOptimizerCargoDetailsWaypointFactory;
